import AdobeCloud from './adobecreativecloud.svg';
import AmazonS3 from './amazons3.svg';
import Box from './box.svg';
import Dropbox from './dropbox.svg';
import GoogleDrive from './googledrive.svg';
import { OutlinedLogo } from './Logo';
import OneDrive from './microsoftonedrive.svg';
import { Twitter } from './Twitter';
export default {
    Annotely: OutlinedLogo,
    AdobeCloud,
    Dropbox,
    Box,
    GoogleDrive,
    OneDrive,
    AmazonS3,
    Twitter,
};
